import Sidebar from "components/SideBar";
import React from "react";
export default function AdminLayout() {
  return (
    <>
      <Sidebar />
    </>
  );
}
